import { Panel } from "../../components/panels/Panel";
import { useGetData } from "../../services/api/api-tools";
import { Fragment, useEffect, useState } from "react";
import { Thumbnail } from "../gallery/event-scores/Thumbnail";
import { formatSecondsToFullDateTime } from "../../helpers/date/date-helper";
import { InboxIcon } from "@heroicons/react/20/solid";
import { ShortsTimeline } from "./components/ShortsTimeline";
import { ShortsVideoBlock } from "./components/ShortsVideoBlock";
import { Loader } from "../../components/loading/Loader";

export const ShortsPage = () => {
  const [records, setRecords] = useState([]);
  const [recordAnnotations, setRecordAnnotations] = useState([]);
  const [videoDuration, setVideoDuration] = useState(null);
  const [videoCurrentTime, setVideoCurrentTime] = useState(0);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [viewOnly, setViewOnly] = useState(true);

  const {
    data: recordsData,
    isLoading: recordsAreLoading,
    refetch: refetchRecords,
  } = useGetData('records', 'records', {});

  useEffect(() => {
    if (recordsAreLoading) return;
    setRecords(recordsData.filter((record) => record?.data?.is_short === 1).sort((r1, r2) => r2.id - r1.id));
    // setSelectedRecord(recordsData.filter((record) => record?.data?.is_short === 1).sort((r1, r2) => r2.id - r1.id)[0]) // TODO REMOVE
  }, [recordsAreLoading]);

  const selectedRecordId = selectedRecord?.id ?? null;

  const {
    data: recordAnnotationsData,
    isLoading: recordAnnotationsAreLoading,
    refetch: refetchRecordAnnotations,
  } = useGetData(
    ['record_annotations', selectedRecordId],
    'record_annotations',
    selectedRecordId ? { record: selectedRecordId } : null,
    !!selectedRecordId
  );

  useEffect(() => {
    if (!selectedRecordId || recordAnnotationsAreLoading) return;
    setRecordAnnotations(recordAnnotationsData ?? []);
  }, [selectedRecordId, recordAnnotationsAreLoading]);

  return (
    <Panel title="CATALOGUE DES SAVOIR-FAIRE">
      <div className="h-full flex gap-4">

        {/* SHORTS GALLERY */}
        <Panel noHeader={true} rounded={true} width="w-1/3" category="secondary" noPadding={true}>
          {records.length > 0 ?
            <div className="grid grid-cols-2 xl:grid-cols-3 gap-4 w-full overflow-y-auto h-full p-4 content-start auto-rows-min">
              {
                records.map((record) => {
                  const thumbnailSrc = `${process.env.REACT_APP_ADDRESS}public/media/records/thumbnails/${record.id}_external-1.jpg`;

                  return (
                    <div
                      key={record.id}
                      className={`h-[150px] w-full aspect-video bg-perception-black-800 bg-cover bg-center rounded-md transition duration-300 text-xs flex justify-end items-end relative overflow-hidden border-2
                      ${selectedRecordId === record.id ? 'border-perception-blue' : 'border-transparent'}
                      ${(record?.data?.video_encoding || record?.data?.video_shortifying) ? '' : 'cursor-pointer hover:transform hover:scale-105'}`}
                      onClick={() => {
                        if (!(record?.data?.video_encoding)) {
                          setViewOnly(true);
                          setSelectedRecord(record);
                        }
                      }}
                    >
                      <Thumbnail src={thumbnailSrc} snapshotData={record.data} />

                      <span className="absolute text-nowrap top-4 left-4 rounded-md backdrop-blur-md bg-white/20 px-2 py-1 text-xs font-medium text-white inline-block">
                        {formatSecondsToFullDateTime(record.date)}
                      </span>
                    </div>
                  )
                })
              }
            </div>
          :
            <div className="h-full flex flex-col justify-center items-center text-center text-perception-gray-700 gap-4">
              {recordsAreLoading ?
                <Loader category="transparent"/> :
                <>
                  <InboxIcon className="size-24" />
                  <span className="text-3xl">Aucun short enregistré</span>
                </>
              }
            </div>
          }
        </Panel>

        {/* SHORT EDITOR */}
        <div className="w-2/3 flex flex-col relative gap-4">
          {recordAnnotationsAreLoading ?
            <div className="h-full flex flex-col items-center justify-center text-3xl text-perception-gray-700">
              <Loader category="transparent"/>
            </div>
          :
            selectedRecord ?
            <>
              <ShortsVideoBlock
                selectedRecord={selectedRecord}
                recordAnnotations={recordAnnotations}
                setRecordAnnotations={setRecordAnnotations}
                setVideoDuration={setVideoDuration}
                setVideoCurrentTime={setVideoCurrentTime}
                viewOnly={viewOnly}
                setViewOnly={setViewOnly}
              />

              {!viewOnly &&
                <ShortsTimeline
                  selectedRecord={selectedRecord}
                  recordAnnotations={recordAnnotations}
                  setRecordAnnotations={setRecordAnnotations}
                  duration={videoDuration ?? 0}
                  currentTime={videoCurrentTime}
                />
              }
            </>
            :
            <div className="h-full flex flex-col items-center justify-center text-3xl text-perception-gray-700">
              Sélectionner un short dans la galerie pour l'éditer
            </div>
          }
        </div>

      </div>
    </Panel>
  );
};
